import { render } from "./Footer.vue?vue&type=template&id=2bee8802&scoped=true&lang=pug"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=2bee8802&lang=scss&scoped=true"
import "./Footer.vue?vue&type=style&index=1&id=2bee8802&lang=scss"
script.render = render
script.__scopeId = "data-v-2bee8802"

export default script